'use client';

import React, { Suspense } from 'react';
import ContentCalendar from '@/components/calendar/ContentCalendar';
import { Box, CircularProgress, Container } from '@mui/material';
import { useSearchParams } from 'next/navigation';

function CalendarWithQuery() {
  const searchParams = useSearchParams();
  const openAdd = searchParams?.get('add') === '1';
  const viewRaw = searchParams?.get('view');
  const initialViewMode =
    viewRaw === 'schedule' ? ('schedule' as const) : viewRaw === 'day' ? ('day' as const) : viewRaw === 'week' ? ('week' as const) : viewRaw === 'month' ? ('month' as const) : undefined;
  return <ContentCalendar initialOpenAddEvent={openAdd} {...(initialViewMode ? { initialViewMode } : {})} />;
}

export default function CalendarPageClient() {
  return (
    <Box
      className="calendar-page"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        minWidth: 0,
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Container
        maxWidth="lg"
        disableGutters={false}
        sx={{
          flex: 1,
          minHeight: 0,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          px: { xs: 2, sm: 3 },
          py: { xs: 2, sm: 3 },
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ flex: 1, minHeight: 0, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
          <Suspense
            fallback={
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, minHeight: 240 }} aria-busy="true">
                <CircularProgress aria-label="Loading calendar" />
              </Box>
            }
          >
            <CalendarWithQuery />
          </Suspense>
        </Box>
      </Container>
    </Box>
  );
}
